import React from 'react'
import { Modal, Form, Input } from 'antd'
import StrongOrWeakPwdInput from './StrongOrWeakPwdInput';
import { ENCRYPT } from '@/utils/utils';

const { TextArea } = Input

const formItemLayout = {
  labelCol: {
    span: 6,
  },
  wrapperCol: {
    span: 14,
  },
}
const ChangePwd = ({ data, form, onOk, permissionList, ...modalProps }) => {

  const { getFieldDecorator } = form
  const handleOk = () => {
    const { validateFields, getFieldsValue } = form

    validateFields(errors => {
      if (errors) {
        return
      }
      const params = getFieldsValue()
      const p = {
        oldPhrase:ENCRYPT(params.oldPhrase),
        newPhrase:ENCRYPT(params.newPhrase)
      }
      onOk(p)
    })
  } 

  const compareToFirstPassword = (rule, value, callback) => {
    if (value && value !== form.getFieldValue('newPhrase')) {
      callback('两次输入的密码不一致');
    } else {
      callback();
    }
  }

  return (
    <Modal {...modalProps} onOk={() => handleOk()}>
      <Form layout="horizontal">
        <Form.Item label="原密码" {...formItemLayout}>
          {getFieldDecorator('oldPhrase', {
              rules: [
                {
                  required: true,
                  message: '请填写原密码'
                },
              ],
            })(
              <Input type="password" />
            )}
        </Form.Item>
        {/* <Form.Item label="新密码" {...formItemLayout}>
          {getFieldDecorator('newPhrase', {
              rules: [
                {
                  required: true,
                  message: '请填写新密码'
                },
              ],
            })(
              <Input type="password" validator={checkPwd}/>
            )}
        </Form.Item> */}
        <Form.Item label="新密码" {...formItemLayout}>
          {getFieldDecorator('newPhrase', {
              rules: [
                {
                  required: true,
                  message: '请填写新密码'
                },
              ],
            })(
              <StrongOrWeakPwdInput type="password" />
            )}
        </Form.Item>
        <Form.Item label="确认密码" {...formItemLayout}>
          {getFieldDecorator('repeatNewPhrase', {
            rules: [
              {
                required: true,
                message: '请填写确认密码'
              },
              {
                validator: (rule, value, callback) => compareToFirstPassword(rule, value, callback),
              },
            ],
          })(
            <Input type="password" />
          )}
        </Form.Item>
      </Form>
    </Modal>
  )
}
export default Form.create()(ChangePwd)